import React, { useEffect, useState } from "react";
import { getAllCategories } from "../services/photoCategoryService";
import { useNavigate } from "react-router-dom";
import { FILE_BASE_URL } from "../utils/constants";

export default function CategoryList() {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getAllCategories().then(setCategories);
  }, []);

  return (
    <div className="container mt-4">
      <h3>📁 Photo Categories</h3>
      <div className="row">
        {categories.map((c) => {
          const imageUrl = c?.photoUrl?.startsWith("http")
            ? c.photoUrl
            : `${FILE_BASE_URL.replace(/\/$/, "")}/${String(c.photoUrl || "").replace(/^\//, "")}`;
          return (
            <div
              className="col-md-3 mb-3"
              key={c.id}
              onClick={() => navigate(`/gallery/${c.id}`)}
              style={{ cursor: "pointer" }}
            >
              <div className="card shadow-sm">
                <img
                  src={imageUrl}
                  className="card-img-top"
                  alt={c.name}
                  style={{ height: 150, objectFit: "cover" }}
                />
                <div className="card-body text-center">
                  <h6>{c.name}</h6>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
